import { useDispatch, useSelector } from "react-redux"
import {
    usePost,
} from "../../api/reactQueryCustomHooks"
import { apiRoute, GetLoginCredentialDb, linksUrl } from "../../constants/enum"
import {
    ErrorCard,
    LoadingCard,
    MainContainer,
    MasterGrid,
    NoDataCard,
} from "../../components"
import {
    Button
} from "@heroui/react"
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useNavigate } from "react-router-dom"
import { useEffect, useMemo, useState } from "react"
import { format } from "date-fns";

const TrailBalanceReport = () => {
    let navigate = useNavigate()
    const { token, user } = useSelector((state) => state.auth)
    const { compCode, compName, isMultipleCompany, startDate, endDate, yearId } = useSelector((state) => state.company)
    const frDate = (date) => (date ? format(new Date(date), "yyyy-MM-dd") : null);
    const [billDate, setBillDate] = useState({
        fromDate: frDate(startDate) || null,
        toDate: frDate(endDate) || null
    })

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)
    }, [])
    const columns = [
        { header: "A/c Description", accessor: "Grp_Desc", type: "text", filterable: true, sortable: false },

        { header: "Open Debit", accessor: "OpBal_Dr", type: "number", filterable: true, align: "right", sortable: false, footer: { type: "sum" } },
        { header: "Open Credit", accessor: "OpBal_Cr", type: "number", filterable: true, align: "right", sortable: false, footer: { type: "sum" } },
        { header: "Tran Debit", accessor: "Debit", type: "number", filterable: true, align: "right", sortable: false, footer: { type: "sum" } },
        { header: "Tran Credit", accessor: "Credit", type: "number", filterable: true, align: "right", sortable: false, footer: { type: "sum" } },
        { header: "Close Debit ", accessor: "Bal_Dr", type: "number", filterable: true, align: "right", sortable: false, footer: { type: "sum" } },
        { header: "Close Credit ", accessor: "Bal_Cr", type: "number", filterable: true, align: "right", sortable: false, footer: { type: "sum" } },
    ];
    const detailColumns = [
        { header: "A/C Id", accessor: "AC_ID", type: "text", filterable: true, sortable: false },
        { header: "A/C Description", accessor: "Ac_Desc", type: "text", filterable: true, sortable: false },
        { header: "Open Debit", accessor: "OpBal_Dr", type: "number", filterable: false, align: "right", sortable: false },
        { header: "Open Credit", accessor: "OpBal_Cr", type: "number", filterable: false, align: "right", sortable: false },
        { header: "Tran Debit", accessor: "Debit", type: "number", filterable: false, align: "right", sortable: false },
        { header: "Tran Credit", accessor: "Credit", type: "number", filterable: false, align: "right", sortable: false },
        { header: "Close Debit ", accessor: "Bal_Dr", type: "number", filterable: false, align: "right", sortable: false },
        { header: "Close Credit ", accessor: "Bal_Cr", type: "number", filterable: false, align: "right", sortable: false },]


    const {
        isError,
        isPending,
        data = [],
        mutate: filterData
    } = usePost({
        url: apiRoute.transactionEntry.getTrialBalanceData,
        queryKey: "Credit Trial Balance Details",

    })

    //console.log(GetLoginCredentialDb())
    const funFilterData = () => {
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: billDate?.fromDate,
                to_date: billDate?.toDate,
            }
        })
    }


    const handleFilter = () => {
        funFilterData();
    }
    const handleClear = () => {
        setBillDate({
            fromDate: startDate || null,
            toDate: endDate || null
        })
        filterData({
            data: {
                compcode: compCode.join(","),
                from_date: startDate,
                to_date: endDate,
            }
        })
    }
    const formatDate = (date) => {
        return new Date(date).toLocaleDateString("en-GB");
    };

    const formatNumber = (num) => {
        return Number(num || 0).toFixed(2);
    };



    if (isError) {
        return <ErrorCard />
    }

    if (isPending) {
        return <LoadingCard />
    }


    return (
        <div>


            <MainContainer
                pageName="Trial Balance Sheet"
                info={[]}
                breadcrumbs={["Reports & view", "Trial Balance Sheet"]}
            >
              
                    <div className="p-2 shadow mb-3 bg-white ">
                        {/* <div className="pb-1 text-sm font-semibold">
                        Inward Date
                    </div> */}
                        <div className="flex gap-2  flex-wrap sm:flex-nowrap md:flex-nowrap justify-center items-center gap-5 ">
                            <div className="flex no-wrap gap-5">
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={"From Date"}
                                        views={["day", "month", "year"]}
                                        size="small"
                                        format="DD/MM/YYYY"
                                        value={
                                            billDate.fromDate
                                                ? dayjs(billDate.fromDate)
                                                : billDate.fromDate
                                        }
                                        onChange={(newValue) => {
                                            setBillDate((prev) => {
                                                return {
                                                    ...prev,
                                                    fromDate: newValue != '' && newValue != 'Invalid Date' ?
                                                        dayjs(newValue).format("YYYY-MM-DD") : null,
                                                };
                                            });
                                        }}
                                        slotProps={{
                                            textField: { size: "small", },
                                        }}
                                    />
                                </LocalizationProvider>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        label={"To  Date"}
                                        views={["day", "month", "year"]}
                                        format="DD/MM/YYYY"
                                        size="small"
                                        value={
                                            billDate.toDate
                                                ? dayjs(billDate.toDate)
                                                : billDate.toDate
                                        }
                                        onChange={(newValue) => {
                                            setBillDate((prev) => {
                                                return {
                                                    ...prev,
                                                    toDate: newValue != '' && newValue != 'Invalid Date' ?
                                                        dayjs(newValue).format("YYYY-MM-DD") : null,
                                                };
                                            });
                                        }}
                                        slotProps={{
                                            textField: { size: "small", },
                                        }}
                                    />
                                </LocalizationProvider>
                            </div>
                            <div className="flex no-wrap gap-5 justify-center items-center">
                                <Button onPress={handleFilter} className="font-semibold uppercase bg-slate-700 text-white" variant="solid" color="primary" size="sm" >Show</Button>
                                <Button onPress={handleClear} className="font-semibold uppercase " variant="solid" color="danger" size="sm" >Reset Date</Button>
                            </div>
                        </div>
                    </div>
                      <div className="bg-white min-h-screen p-3">
                    {data && data.length > 0 ?
                        <MasterGrid
                            columns={columns}
                            detailColumns={detailColumns}
                            groupKey={"Grp_Desc"}
                            data={data}
                            className={""}
                            showPaging={false}
                            pageSize={20}
                            expandableRow={true}
                            showDiffBal={true}
                            headClass={"bg-slate-200 border-1 border-slate-300"}
                            filterClass={"bg-gray-50 border-1 border-slate-300"}
                            style={{ border: "1px solid red" }}
                            exportHeader={{
                                companyName: compName.join(","),
                                reportName: `Group Wise Trial Balance Sheet From Date ${formatDate(billDate.fromDate)} To ${formatDate(billDate.toDate)}`,

                            }}
                        ></MasterGrid> : <NoDataCard />}
                </div>
            </MainContainer>
        </div>
    )
}
export default TrailBalanceReport
